import {useEffect, useState} from 'react';
import {usePermissions} from './usePermissions';

export const useHeartbeatPermissions = (): boolean => {
  const permissionsMap = usePermissions();
  const [hasHeartbeatPermissions, setHasHeartbeatPermissions] = useState<boolean>(false);
  useEffect(() => {
    if (permissionsMap.size === 0) {
      setHasHeartbeatPermissions(false);
      return;
    }
    for (const perms of permissionsMap.values()) {
      if (!perms.includes('order_processing')) {
        setHasHeartbeatPermissions(false);
        return;
      }
    }
    setHasHeartbeatPermissions(true);
  }, [permissionsMap]);
  return hasHeartbeatPermissions;
};
